import page from "@homer.core/page";
import reset from "@shared/reset";

const onHashChange = () => {
    if (location.hash === "#reset") {
        reset().finally(() => {
            location.hash = "";

            page.replace(location.href.slice(0, -1));
            location.reload();
        });
    }
};

globalThis.addEventListener("hashchange", onHashChange);
onHashChange();
